import {
  IKpiData,
  IFoodChartPoint,
  IMealTypeRow,
  IAccommodationChartPoint,
  ICampRow,
} from '../hrAnalytics.types'

export const MOCK_FOOD_KPIS: IKpiData[] = [
  {
    value: '4,440',
    label: 'MEALS PLANNED',
    accentColor: '#30B6D1',
    iconKey: 'food',
  },
  {
    value: '4,063',
    label: 'MEALS SERVED',
    accentColor: '#00B04C',
    iconKey: 'checkCircle',
  },
  {
    value: '260',
    label: 'STAND BY USED',
    sublabel: 'Buffer Meals',
    accentColor: '#ff9900',
    iconKey: 'warning',
  },
  {
    value: '4.5%',
    label: 'WASTE INDICATOR',
    accentColor: '#FF4F46',
    iconKey: 'chart',
  },
]

export const MOCK_FOOD_CHART: IFoodChartPoint[] = [
  { day: 'Mon', planned: 70, served: 85, standbyUsage: 50 },
  { day: 'Tue', planned: 80, served: 90, standbyUsage: 52 },
  { day: 'Wed', planned: 65, served: 70, standbyUsage: 48 },
  { day: 'Thu', planned: 72, served: 78, standbyUsage: 55 },
  { day: 'Fri', planned: 88, served: 92, standbyUsage: 50 },
  { day: 'Sat', planned: 75, served: 85, standbyUsage: 52 },
]

export const MOCK_MEAL_TYPE_TABLE: IMealTypeRow[] = [
  { mealType: 'Breakfast', planned: 3200, served: 3100, standbyUsed: 50, utilizationRate: 94.3 },
  { mealType: 'Lunch', planned: 2800, served: 2700, standbyUsed: 35, utilizationRate: 90 },
  { mealType: 'Dinner', planned: 2800, served: 2600, standbyUsed: 35, utilizationRate: 89.4 },
]

export const MOCK_ACCOMMODATION_KPIS: IKpiData[] = [
  {
    value: '200',
    label: 'TOTAL BEDS',
    accentColor: '#30B6D1',
    iconKey: 'bed',
  },
  {
    value: '164',
    label: 'AVERAGE OCCUPANCY',
    sublabel: '82%',
    accentColor: '#00B04C',
    iconKey: 'checkCircle',
  },
  {
    value: '23',
    label: 'GUEST STAYS',
    sublabel: 'Non-Employee Stays',
    accentColor: '#9C27B0',
    iconKey: 'person',
  },
]

export const MOCK_ACCOMMODATION_CHART: IAccommodationChartPoint[] = [
  { date: 'Apr 1', normal: 50, high: 0, overCapacity: 0, capacity: 200 },
  { date: 'Apr 2', normal: 55, high: 0, overCapacity: 0, capacity: 200 },
  { date: 'Apr 3', normal: 65, high: 0, overCapacity: 0, capacity: 200 },
  { date: 'Apr 4', normal: 80, high: 0, overCapacity: 0, capacity: 200 },
  { date: 'Apr 5', normal: 100, high: 0, overCapacity: 0, capacity: 200 },
  { date: 'Apr 6', normal: 120, high: 10, overCapacity: 0, capacity: 200 },
  { date: 'Apr 7', normal: 130, high: 40, overCapacity: 0, capacity: 200 },
  { date: 'Apr 8', normal: 120, high: 50, overCapacity: 10, capacity: 200 },
  { date: 'Apr 9', normal: 110, high: 60, overCapacity: 20, capacity: 200 },
  { date: 'Apr 10', normal: 100, high: 55, overCapacity: 15, capacity: 200 },
]

export const MOCK_CAMP_TABLE: ICampRow[] = [
  { campName: 'Camp Bravo', totalBeds: 80, avgOccupied: 66, avgAvailable: 14, occupancyRate: 94.3 },
  { campName: 'Camp Alpha', totalBeds: 120, avgOccupied: 98, avgAvailable: 22, occupancyRate: 89.4 },
]
